import { type Query } from './adaptor';

export function asQueryRef<T>(colRef: Query<unknown>): Query<T> {
  return colRef as Query<T>;
}
